const stpIndicator = require('../../../asset/image/stpIndicator.png'),
    renewalIndicator = require('../../../asset/image/renewalIndicator.png'),
    referredToIcon = require('../../../asset/image/referredToIcon.png'),
    referredFromIcon = require('../../../asset/image/referredFromIcon.png'),
    referralClearedIcon = require('../../../asset/image/referralClearedIcon.png');

/*@ngInject*/
const IconViewerController = function ($scope, localization, coreMediator, submissionTransactionType, agentQuoteStatus, submissionReferralStatus, xmlUtil, appTypeConfigurationModel) {

    localization.setupLocale('iconViewer', require('./iconViewer.i18n.json'));

    this.$onInit = function () {
        this.displayCustomIcons = false;

        this.getNonCustomIcons();
        this.getAgentQuotingIcon();

        if (_.isNil(this.customIcons)) {
            this.getCustomIcons();
        }
    };

    this.$onChanges = function () {
        if (this.item.customIconNames) {
            this.getCustomIcons();
        } else {
            this.customIcons = null;
        }
    };

    this.getAgentQuotingIcon = function () {
        this.agentQuotingIcon = {
            description: i18n.t('iconViewer|icons.eligibleQuoting')
        };

        coreMediator.getConfiguredFile('agentQuotingIcon').then((configuredFile) => {
            if (!_.isEmpty(configuredFile)) {
                coreMediator.getConfiguredFileData(configuredFile.id).then((data) => {
                    this.agentQuotingIcon.source = `data:${configuredFile.mimeType};base64,${data}`;

                    if (_.isEmpty(this.agentQuotingIcon.description)) {
                        this.agentQuotingIcon.description = configuredFile.description;
                    }
                });
            } else {
                this.agentQuotingIcon.source = stpIndicator;
            }
        });
    };

    this.getCustomIcons = function () {
        this.customIcons = [];

        if (!_.isNil(this.item)) {
            _.each(this.item.customIconNames, (icon) => {
                coreMediator.getConfiguredFile(icon.customIconName).then((configuredFile) => {
                    if (!_.isEmpty(configuredFile)) {
                        coreMediator.getConfiguredFileData(configuredFile.id).then((data) => {
                            icon.source = `data:${configuredFile.mimeType};base64,${data}`;

                            const i18nKey = `iconViewer|icons.${configuredFile.name}`;

                            if (icon.text) {
                                icon.description = icon.text;
                            } else if (i18n.exists(i18nKey)) {
                                icon.description = i18n.t(i18nKey);
                            } else {
                                icon.description = configuredFile.description;
                            }

                            this.customIcons.push(icon);
                            this.displayCustomIcons = true;
                        });
                    }
                });
            });
        }
    };

    this.getNonCustomIcons = function () {
        this.nonCustomIcons = {
            renewalIcon: {
                description: i18n.t('iconViewer|icons.renewalSubmission'),
                source: renewalIndicator
            },
            referredCurrentIcon: {
                description: i18n.t('iconViewer|icons.referredCurrent'),
                source: referredToIcon
            },
            referredOtherIcon: {
                description: i18n.t('iconViewer|icons.referredOther'),
                source: referredFromIcon
            },
            referralClearedIcon: {
                description: i18n.t('iconViewer|icons.referralCleared'),
                source: referralClearedIcon
            }
        };
    };

    this.showRenewalIcon = function () {
        if (!_.isNil(this.item)) {
            return this.item.transactionType === submissionTransactionType.RENEWAL;
        }
        return false;
    };

    this.showReferredCurrentIcon = function () {
        if (!_.isNil(this.item)) {
            return this.item.referredUnderwriterSummary && this.item.referredUnderwriterSummary.id === this.userId;
        }
        return false;
    };

    this.showReferredOtherIcon = function () {
        let isNotAgentConsole,
            agentQuotingEnabled,
            notAgentConsoleOrSTP;

        if (!_.isNil(this.item)) {
            isNotAgentConsole = !appTypeConfigurationModel.isAgentConsole();
            agentQuotingEnabled = this.item.agentQuoteStatus === agentQuoteStatus.ENABLED;
            notAgentConsoleOrSTP = isNotAgentConsole || agentQuotingEnabled;

            return this.item.referredUnderwriterSummary && this.item.referredUnderwriterSummary.id !== this.userId && notAgentConsoleOrSTP;
        }
        return false;
    };

    this.showEligibleQuotingIcon = function () {
        if (!_.isNil(this.item)) {
            return this.item.agentQuoteStatus === agentQuoteStatus.ENABLED;
        }
        return false;
    };

    this.showReferralClearedIcon = function () {
        let isNotAgentConsole,
            agentQuotingEnabled,
            notAgentConsoleOrSTP;

        if (!_.isNil(this.item)) {
            isNotAgentConsole = !appTypeConfigurationModel.isAgentConsole();
            agentQuotingEnabled = this.item.agentQuoteStatus === agentQuoteStatus.ENABLED;
            notAgentConsoleOrSTP = isNotAgentConsole || agentQuotingEnabled;

            return this.item.referralStatus === submissionReferralStatus.CLEAR_REFERRAL && notAgentConsoleOrSTP;
        }
        return false;
    };
};

angular.module('umCore')
    .controller('iconViewerController', IconViewerController);
